module.exports = __webpack_public_path__ + "img/coupon_six.30f2f630.webp";